export class FormaPgtoResponse {
    nome: string;
    codigo: number;
}

export class FormaPgtoRequestV1 {
    public valor: number = 0;
    public nome: string = '';
    public codigo: number = 0;
}